export const MINIMUM_LUNCHER_COUNT = 30
